import {createSelector} from 'reselect'
import {getFullUserInfo} from '../../userData/selectors'
import {selectUserPanel} from '../../selector'
import {getUserManagementData} from '../../../../administration/userManagement/common/selectors'

const getUserRatesSectionState = createSelector(
    selectUserPanel,
    (userPanel) => userPanel.userRates
)

export const getUserRates = createSelector(
    getFullUserInfo,
    userInfo => userInfo.rates ? userInfo.rates : []
)

export const getOvertimeLevel = createSelector(
    getFullUserInfo,
    (userInfo) => userInfo.overtimeLevel
)

export const getUserManagementDataForUserRates = createSelector(
    getUserManagementData,
    (userManagementData) => ({
        defaultWorkSchedule: userManagementData.defaultWorkSchedule,
        currentDate: userManagementData.todayInViewerTimeZone,
        weekStartDay: userManagementData.weekStartDay,
        invertedDaysMap: userManagementData.defaultWorkSchedule,
        activeLeaveTypes: userManagementData.activeLeaveTypes,
        overtimeRateCoefficient: userManagementData.overtimeRateCoefficient,
    })
)

export const getErrors = createSelector(
    getUserRatesSectionState,
    (userRates) => userRates.errors
)

export const getLastEditedUserRate = createSelector(
    getUserRatesSectionState,
    (userRates) => userRates.lastEditedUserRate
)

export const isUpdating = createSelector(
    getUserRatesSectionState,
    (userRates) => userRates.updating
)


// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/userRates/selectors.js